/**
 * Generate random string
 * @param length
 * @param chars
 * @returns
 */
export function randomString(length: number, chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ') {
  let result = '';
  while (result.length < length) {
    result += chars[Math.round(Math.random() * (chars.length - 1))];
  }
  return result;
}

/**
 * makes first letter of string uppercase
 */
export function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function humanizePropertyKey(key: string): string {
  return key
    .replace(/([a-z])([A-Z])/g, '$1 $2') // Add space between camelCase words
    .toLocaleLowerCase()
    .replace(/^(hs_|crm_)/, '') // Remove prefix
    .replace(/\./g, ' ') // Replace dots with spaces
    .replace(/_/g, ' ') // Replace underscores with spaces
    .replace(/-/g, ' ') // Replace dash with spaces
    .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
}
